import { config } from '@finn-no/huck-config'
import { price, selected, messages, offerIsNull } from './store.js'
import ky from 'ky'

export const update = async ({ sellerAction, values }) => {
  try {
    const json = { adId: config.adId, sellerAction, ...values, listedPrice: price.value }
    const responseJson = await ky.post('/pf/api/v1/bbg-seller', { json, headers: config.headers }).json()
    offerIsNull.value = !responseJson.offer
    selected.value = responseJson.offer?.isPledgeChecked ?? false
    price.value = responseJson.offer?.price ?? null
    messages.info = responseJson.infoMessage
    messages.warning = responseJson.warningMessage
  } catch (err) {
    console.error(`Error from pf-bbg-seller`, err)
    offerIsNull.value = true
    price.value = null
    messages.info = []
    messages.warning = []
  }
}
